import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-linear-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "max-w-md w-full space-y-8 text-center" };
const _hoisted_3 = { class: "relative" };
const _hoisted_4 = { class: "flex justify-center" };
const _hoisted_5 = { class: "space-y-6" };
const _hoisted_6 = { class: "space-y-2" };
const _hoisted_7 = { class: "text-3xl font-bold text-gray-900" };
const _hoisted_8 = { class: "text-lg text-gray-600" };
const _hoisted_9 = { class: "bg-white rounded-lg shadow-xs border border-gray-200 p-6 text-left" };
const _hoisted_10 = { class: "text-lg font-semibold text-gray-900 mb-4" };
const _hoisted_11 = { class: "space-y-3" };
const _hoisted_12 = { class: "flex items-center text-gray-700" };
const _hoisted_13 = { class: "flex items-center text-gray-700" };
const _hoisted_14 = { class: "flex items-center text-gray-700" };
const _hoisted_15 = { class: "flex items-center text-gray-700" };
const _hoisted_16 = { class: "flex flex-col sm:flex-row gap-4 justify-center" };
const _hoisted_17 = { class: "pt-6 border-t border-gray-200" };
const _hoisted_18 = { class: "text-sm text-gray-500" };
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Loader from "@/presentation/components/Loader.vue";
// Composables
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotFound',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        // Navigation methods
        const goHome = () => {
            router.push("/dashboard");
        };
        const goBack = () => {
            // Go back in history if possible, otherwise go home
            if (window.history.length > 1) {
                router.go(-1);
            }
            else {
                goHome();
            }
        };
        const contactSupport = () => {
            // In a real application, this would open a support chat or email
            // For now, we'll show an alert with support information
            alert(t("notFound.contactSupport.message"));
        };
        // Set the document title
        onMounted(() => {
            document.title = `${t("notFound.title")} - OPAY`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(Loader, { class: "scale-150" })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(t)("notFound.heading")), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("notFound.description")), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(t)("notFound.suggestions.title")), 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_11, [
                                _createElementVNode("li", _hoisted_12, [
                                    _cache[0] || (_cache[0] = _createElementVNode("svg", {
                                        class: "w-5 h-5 text-blue-500 mr-3 shrink-0",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    ], -1 /* CACHED */)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.suggestions.checkUrl")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("li", _hoisted_13, [
                                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                        class: "w-5 h-5 text-blue-500 mr-3 shrink-0",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M4 6h16M4 12h16M4 18h16"
                                        })
                                    ], -1 /* CACHED */)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.suggestions.useNavigation")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("li", _hoisted_14, [
                                    _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                        class: "w-5 h-5 text-blue-500 mr-3 shrink-0",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m0 0V11a1 1 0 011-1h2a1 1 0 011 1v10m3 0a1 1 0 001-1V10m0 0l2 2m-2-2v10a1 1 0 01-1 1h-3"
                                        })
                                    ], -1 /* CACHED */)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.suggestions.goHome")), 1 /* TEXT */)
                                ]),
                                _createElementVNode("li", _hoisted_15, [
                                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                        class: "w-5 h-5 text-blue-500 mr-3 shrink-0",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    ], -1 /* CACHED */)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.suggestions.contactSupport")), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                                class: "inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200",
                                onClick: goBack
                            }, [
                                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                    class: "w-5 h-5 mr-2",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M15 19l-7-7 7-7"
                                    })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.actions.goBack")), 1 /* TEXT */)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("notFound.suggestions.contactSupport")), 1 /* TEXT */),
                            _createElementVNode("button", {
                                class: "mt-2 inline-flex items-center text-sm text-blue-600 hover:text-blue-800 transition-colors duration-200",
                                onClick: contactSupport
                            }, [
                                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                    class: "w-4 h-4 mr-1",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                    })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("notFound.actions.contactSupport")), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
